module.exports = __webpack_public_path__ + "static/media/cases_brand_midias_otica.4fed72f7.jpg";